<template>
  <div>
    <b-card
      :title="cardTitle"
      class="rounded-lg"
    >
      <b-card-text> {{ $t("HomeCard.Subtitle") }} </b-card-text>
      <b-card-text>
        <b-row>
          <Loading v-if="statsLoading" />

          <template v-else>
            <b-col
              v-if="stats.length == 0"
              xl="12"
              sm="12"
            >
              <b-card
                class="shadow"
                no-body
                style="height: 100px"
              >
                <b-card-body class="shadow rounded-lg">
                  <b-media
                    no-body
                    class=""
                  >
                    <b-media-aside class="mr-2">
                      <b-avatar
                        size="60"
                        variant="light-primary"
                      >
                        <feather-icon
                          size="40"
                          icon="SmileIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        {{ $t("HomeCard.EmptyStats") }}
                      </h4>
                    </b-media-body>
                  </b-media>
                </b-card-body>
              </b-card>
            </b-col>

            <template v-else>
              <b-col
                v-for="(item, index) in stats"
                :key="index"
                xl="3"
                sm="6"
              >
                <b-card
                  class="shadow"
                  no-body
                  style="height: 100px"
                >
                  <b-card-body
                    class="shadow rounded-lg"
                    style="padding-right: 10px; padding-left: 10px"
                  >
                    <b-media
                      no-body
                      class=""
                    >
                      <b-media-aside class="mr-2">
                        <b-avatar
                          size="48"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="24"
                            icon="FileTextIcon"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body class="my-auto">
                        <b-card-text class="font-small-3 mb-0">
                          {{ $t(`HomeCard.Stats.${item.label}`) }}
                        </b-card-text>
                        <h4 class="font-weight-bolder mb-0">
                          {{ item.value }}
                        </h4>
                      </b-media-body>
                    </b-media>
                  </b-card-body>
                </b-card>
              </b-col>
            </template>
          </template>
        </b-row>
      </b-card-text>

      <b-card-text>
        <b-row>
          <b-col cols="12">
            <b-card
              no-body
              class="shadow"
            >
              <b-card-body class="shadow rounded-lg">
                <Loading v-if="!currentPackageLoaded" />
                <b-row v-else>
                  <b-col
                    xl="3"
                    sm="6"
                  >
                    <img
                      width="200px"
                      src="@/assets/icon/subscription-outline.png"
                      alt=""
                    >
                  </b-col>
                  <b-col
                    xl="9"
                    sm="6"
                    class="d-flex my-auto align-content-center flex-column"
                    style="gap: 0.5rem"
                  >
                    <h4 class="font-weight-bolder mb-0">
                      {{ $t("HomeCard.CurrentPlan") }}
                    </h4>
                    <ul class="pl-2 mb-0">
                      <span
                        v-for="(data, index) in current_package"
                        :key="index"
                      >
                        <li class="font-weight-bolder">
                          {{ data.package.package_name }}
                        </li>

                        <li
                          v-for="(featureItem, index) in data[feature]"
                          :key="index"
                          class="font-weight-bolder"
                        >
                          {{ featureItem }}
                        </li>
                      </span>
                    </ul>

                    <div
                      class="d-flex justify-content-lg-end justify-content-center"
                    >
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        :to="{ name: 'subscription' }"
                        variant="primary"
                      >
                        {{ $t("HomeCard.UpgradePlanBtn") }}
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { getUserData } from '@/auth/utils'
import { getSubscribersMixins } from '@/mixins/getSubscribersMixins'
import { selectLocalizedField } from '@/libs/i18n/currentLocale'

export default {
  directives: {
    Ripple,
  },
  mixins: [getSubscribersMixins],
  data() {
    return {
      userData: getUserData(),
      current_package: [],
      currentPackageLoaded: false,
      stats: [],
      statsLoading: true,
      date: new Date(),
    }
  },
  computed: {
    cardTitle() {
      return `${this.$i18n.t('Message.welcome')} ${this.$i18n.t(
        'Message.back',
      )}, ${this.userData.full_name}!`
    },
    feature() {
      return selectLocalizedField(this.$i18n, 'swe_features', 'features')
    },
  },

  mounted() {
    this.init()
  },

  methods: {
    getStats() {
      this.stats = []

      this.$useJwt
        .stats({
          params: {
            month: this.date.getMonth() + 1,
          },
        })
        .then(res => {
          const { results } = res.data

          results.forEach(element => {
            this.stats.push(
              {
                label: 'bookkeep',
                value: element.no_of_invoices_booked,
              },
              {
                label: 'sentdirectly',
                value: element.no_of_invoices_sent_regular,
              },
              {
                label: 'sentfortnox',
                value: element.no_of_invoices_sent_nox,
              },
              {
                label: 'total',
                value: element.no_of_total_invoices_handled,
              },
            )
          })
        })
        .finally(() => (this.statsLoading = false))
    },
    async getCurrentPlanFeature() {
      this.currentPackageLoaded = false
      this.current_package = []

      // Resolve current plan information from subscription
      let currentPlanId = []
      let currentPackageName = null
      let currentPackageLevel = null
      try {
        currentPlanId = await this.getCurrentPlan()
        // Also pull name/level for robust matching
        const subsRes = await this.getSubscriptions()
        const first = subsRes && subsRes.data && Array.isArray(subsRes.data.data)
          ? subsRes.data.data[0]
          : null
        if (first && first.current_package) {
          currentPackageName = first.current_package.package_name
          currentPackageLevel = first.current_package.level
        }
      } catch (e) {
        currentPlanId = []
      }

      this.$useJwt
        .packages()
        .then(res => {
          const results = res && res.data && Array.isArray(res.data.results)
            ? res.data.results
            : []

          // Prefer exact id match; fallback to name or level
          const curId = Array.isArray(currentPlanId) ? currentPlanId[0] : null
          const match = results.find(element => {
            if (!element || !element.package) return false
            const pkg = element.package || {}
            const byId = curId != null && curId == pkg.id
            const byName = currentPackageName
              && typeof pkg.package_name !== 'undefined'
              && String(pkg.package_name).toLowerCase()
                === String(currentPackageName).toLowerCase()
            const byLevel = currentPackageLevel != null && currentPackageLevel == pkg.level
            return byId || byName || byLevel
          })

          if (match) {
            this.current_package = [match]
          } else if (currentPackageName) {
            // Fallback: render minimal card from subscription if packages list didn't match
            this.current_package = [
              {
                package: {
                  id: curId,
                  level: currentPackageLevel,
                  package_name: currentPackageName,
                },
                features: [],
                swe_features: [],
              },
            ]
          } else {
            this.current_package = []
          }
        })
        .catch(() => {
          this.current_package = []
        })
        .finally(() => {
          this.currentPackageLoaded = true
        })
    },

    init() {
      this.getStats()
      this.getCurrentPlanFeature()
    },
  },
}
</script>

<style></style>
